export const DELIVERISE_SEARCH_CONSTANT = {
  // csvファイル名
  CSV_FILENAME: 'deliveries',
  // 対象テーブル
  TARGET_TABLE: 'delivery_view',
};
